import * as React from 'react';
import { getABTestExperiment } from 'store/abTest';
import { PROJECT_NAME, FEATURE_ID } from '../constants';
import { addCustomOpsMetric } from 'utils/metrics';
import { useAppSelector } from 'store/utils/hooks';

const getRandomNumber = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const ABTestPOCButton = () => {
  const experiment = useAppSelector(getABTestExperiment);

  React.useEffect(() => {
    if (experiment?.value && experiment?.variation) {
      addCustomOpsMetric({
        metricList: [
          {
            metricName: 'abTestCTR',
            metricValue: experiment?.value?.boolValue ? getRandomNumber(1, 20) : getRandomNumber(21, 40),
            metricDetails: 'AB Test POC from MMM out of console',
            metricUnit: 'Milliseconds',
          },
        ],
        properties: [
          {
            propertyName: 'ABTestProjectName',
            propertyValue: PROJECT_NAME,
          },
          {
            propertyName: 'ABTestFeatureID',
            propertyValue: FEATURE_ID,
          },
          {
            propertyName: 'EvaluateFeatureValueStringified',
            propertyValue: JSON.stringify(experiment),
          },
          {
            propertyName: 'EvaluateFeatureValue',
            propertyValue: experiment.variation,
          },
        ],
      });
    }
  }, [experiment]);

  return (
    <>
      {experiment && (
        <div
          id="howser_abtesting_poc_button"
          data-analytics-type="eventDetails"
          data-analytics={`${experiment?.value?.boolValue ? 'ABTest_POC_Enabled' : 'ABTest_POC_Disabled'}`}
          data-analytics-render
        >
          <button style={{ visibility: 'hidden' }}>
            {experiment?.value?.boolValue ? 'ABTest_POC_Enabled' : 'ABTest_POC_Disabled'}
          </button>
        </div>
      )}
    </>
  );
};
